/**
 * Дедупликация realtime project:updated — избегаем двойного применения
 * (оптимистичная мутация + ответ сервера + realtime дают моргание).
 */
const DEDUP_MS = 800;
const updatedByMutationAt = new Map<string, number>();

export function markProjectUpdatedByMutation(projectId: string): void {
  updatedByMutationAt.set(projectId, Date.now());
  if (updatedByMutationAt.size > 200) {
    const now = Date.now();
    for (const [id, t] of updatedByMutationAt.entries()) {
      if (now - t > DEDUP_MS) updatedByMutationAt.delete(id);
    }
  }
}

export function shouldSkipRealtimeProjectUpdate(projectId: string): boolean {
  const t = updatedByMutationAt.get(projectId);
  if (!t) return false;
  if (Date.now() - t > DEDUP_MS) {
    updatedByMutationAt.delete(projectId);
    return false;
  }
  return true;
}
